import fr from './translations/fr.json';
import en from './translations/en.json';
import pt from './translations/pt.json';

const dictionaries = {
  fr,
  en,
  pt,
};

export const supportedLanguages = ['fr', 'en', 'pt'];

export function translate(lang, key) {
  const dict = dictionaries[lang] || dictionaries.fr;
  if (!key || typeof key !== 'string') {
    return '';
  }
  const segments = key.split('.');
  let current = dict;
  for (const segment of segments) {
    if (current && Object.prototype.hasOwnProperty.call(current, segment)) {
      current = current[segment];
    } else {
      return key;
    }
  }
  if (typeof current === 'string') {
    return current;
  }
  return key;
}

export function translateWithLanguage(lang, key) {
  return translate(lang, key);
}
